import React from 'react';
import './WaiverPage.css';

const WaiverPage: React.FC = () => {
  return (
    <div className="waiver-page">
      <section className="waiver-hero">
        <div className="container">
          <h1>Training Waiver</h1>
          <p className="subtitle">Required before your first session</p>
        </div>
      </section>

      <section className="waiver-content">
        <div className="container">
          <div className="waiver-intro">
            <h2>Before We Get Started</h2>
            <p>
              Before your first training session, we need a signed waiver on file. This protects both you and Xcelerate Football 
              during training activities.
            </p>
            <div className="waiver-requirements">
              <div className="requirement-item">
                <span className="requirement-icon">📋</span>
                <div>
                  <h3>For Athletes Under 18</h3>
                  <p>A parent or legal guardian must complete and sign this form</p>
                </div>
              </div>
              <div className="requirement-item">
                <span className="requirement-icon">✍️</span>
                <div>
                  <h3>For Athletes 18+</h3>
                  <p>You can complete and sign the form yourself</p>
                </div>
              </div>
              <div className="requirement-item">
                <span className="requirement-icon">⚡</span>
                <div>
                  <h3>Quick & Easy</h3>
                  <p>Takes less than 5 minutes to complete</p>
                </div>
              </div>
            </div>
          </div>

          <div className="jotform-container">
            <iframe
              id="JotFormIFrame-253075312201038"
              title="Waiver Form"
              allowTransparency={true}
              allow="geolocation; microphone; camera; fullscreen"
              src="https://form.jotform.com/253075312201038"
              frameBorder="0"
              style={{
                minWidth: '100%',
                maxWidth: '100%',
                height: '1200px',
                border: 'none'
              }}
              scrolling="yes"
            />
          </div>

          <div className="waiver-footer">
            <p>
              <strong>Questions about the waiver?</strong> Call or text Coach Mesa at{' '}
              <a href="tel:530-788-5017">530-788-5017</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WaiverPage;

